import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  Inject,
  Optional
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";

@Component({
    selector: "ticket-details-modal",
    templateUrl: "./ticket-details-modal.component.html",
    styleUrls: ["./ticket-details-modal.component.scss"],
    standalone: true,
    imports: [CommonModule, MatDialogModule]
})
export class TicketDetailsModalComponent {
  @Input() ticket = null;
  @Output() close = new EventEmitter();

  get hours(): number {
    return Math.floor(this.ticket.elapsed_time / 60);
  }

  get minutes(): number {
    return Math.floor(this.ticket.elapsed_time % 60);
  }

  constructor(
    public dialogRef: MatDialogRef<TicketDetailsModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { ticket } = this.data;
    this.ticket = ticket;
  }

  closeModal() {
    this.close.emit();
    this.ticket = null;
    this.dialogRef.close(null);
  }
}
